import { Form, Row, Col, FormInstance, Select } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { InputDecimal } from '@/components/_common';
import SituationFormField from '@/components/Movements/DirectSale/SituationFormField';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import CfopSelectField from '@/components/_common/CfopSelectField';
import { PurchaseUpdateRequest } from '@/core/domain/purchase/Purchase.types';
import PurcheseAlertBoshMigration from '../../PurchaseAlertBoshMigration';

interface Props {
  form: FormInstance<PurchaseUpdateRequest>;
}

function PurchaseDataFreightForm({ form }: Props) {
  const { situation, purchase, purchaseReadOnly } =
    useReleasePurchaseFormContext();

  const cstCodes = [
    { id: 1, code: '00' },
    { id: 2, code: '10' },
    { id: 3, code: '20' },
    { id: 4, code: '30' },
    { id: 5, code: '40' },
    { id: 6, code: '41' },
    { id: 7, code: '50' },
    { id: 8, code: '51' },
    { id: 9, code: '60' },
    { id: 10, code: '70' },
    { id: 11, code: '90' },
  ];

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        name="purchaseDataFreight"
        disabled={purchaseReadOnly}
      >
        <Row gutter={[16, 9]}>
          <Col span={24}>
            <SituationFormField initialValue={situation} />
          </Col>

          {purchase?.boschMigration && (
            <Col span={24}>
              <PurcheseAlertBoshMigration />
            </Col>
          )}

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem name="freightCstIcms" label="CST ICMS">
              <Select
                options={cstCodes?.map((code) => ({
                  value: code.code,
                  label: code.code,
                }))}
              />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem label={'BC ICMS'} name="freightBaseIcms">
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem label={'Alíq. ICMS'} name="freightQuotaIcms">
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={'Valor ICMS'}
              name="freightValueIcms"
              initialValue={0}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <FloatingFormItem label={'CFOP'} name="freightCfopId">
              <CfopSelectField />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default PurchaseDataFreightForm;
